import React from 'react';
import { Route } from 'react-router-dom';
import ListPlanes from "./ListPlanes";
import PlanesEdit from "./PlanesEdit";
import PlanesNew from "./PlanesNew";
import Busqueda from "./Busqueda";

export default class AdmPlanes extends React.Component{

    render(){
        return(
            <div>
                <Route exact path="/Planes" component={ListPlanes}/>
                <Route exact path="/Planes/Editar/:id" component={PlanesEdit}/>
                <Route exact path="/Planes/Nuevo" component={PlanesNew}/>
                <Route exact path="/Planes/Busqueda" component={Busqueda}/>
            </div>
        );
    }
}